import { ref, computed } from 'vue'

export function useContextMenu() {
    // Variables para el long press
    const longPressTimer = ref<ReturnType<typeof setTimeout> | null>(null)
    const longPressDelay = 500
    const touchStartTime = ref(0)
    const touchMoved = ref(false)
    const longPressTriggered = ref(false)

    // Variables para el menú contextual
    const isMenuVisible = ref(false)
    const menuPosition = ref({ x: 0, y: 0 })
    const menuElement = ref<HTMLElement | null>(null)
    const contextUnitId = ref<string | null>(null)

    type MenuOption = 'online' | 'missionPlan' | 'events' | 'seguir' | 'showTrack'

    const menuStyle = computed(() => {
        return {
            position: 'fixed',
            left: `${menuPosition.value.x - 200}px`,
            bottom: `${50}px`,
            zIndex: 1050,
            display: isMenuVisible.value ? 'block' : 'none'
        }
    })

    // ========== FUNCIONES DE MENÚ CONTEXTUAL ==========

    const selectOption = (option: MenuOption, unit_id: string | null, handleShowVideoLive: (unitId: string) => void) => {
        console.log(`Opción seleccionada: ${option}`)
        closeMenu()

        switch (option) {
            case 'online':
                handleShowVideoLive(unit_id || '')
                break
            case 'missionPlan':
            case 'events':
                // La lógica ya está manejada por los handlers de checkbox
                break
        }
    }

    const closeMenu = () => {
        isMenuVisible.value = false
    }

    const openContextMenu = (e: MouseEvent, unitId?: string) => {
        console.log('Abriendo menú contextual')
        e.preventDefault()
        e.stopPropagation()
        contextUnitId.value = unitId || null
        menuPosition.value = {
            x: e.clientX,
            y: e.clientY - 50
        }
        isMenuVisible.value = true
    }

    const handleClickOutside = (e: MouseEvent) => {
        if (menuElement.value && !menuElement.value.contains(e.target as Node)) {
            closeMenu()
        }
    }

    const handleKeydown = (e: KeyboardEvent) => {
        if (e.key === 'Escape') {
            closeMenu()
        }
    }

    // ========== FUNCIONES DE TOUCH ==========

    const handleTouchStart = (e: TouchEvent, unitId: string) => {
        touchStartTime.value = Date.now()
        touchMoved.value = false
        longPressTriggered.value = false

        if (longPressTimer.value) {
            clearTimeout(longPressTimer.value)
        }

        longPressTimer.value = setTimeout(() => {
            if (!touchMoved.value) {
                longPressTriggered.value = true
                console.log('Long press detectado en:', unitId)

                const touch = e.touches[0]
                const simulatedEvent = {
                    clientX: touch.clientX,
                    clientY: touch.clientY,
                    preventDefault: () => { },
                    stopPropagation: () => { }
                } as MouseEvent

                openContextMenu(simulatedEvent, unitId)
                e.preventDefault()
            }
        }, longPressDelay)
    }

    const handleTouchEnd = (e: TouchEvent, unitId: string) => {
        const touchDuration = Date.now() - touchStartTime.value

        if (longPressTimer.value) {
            clearTimeout(longPressTimer.value)
            longPressTimer.value = null
        }

        if (longPressTriggered.value) {
            e.preventDefault()
            e.stopPropagation()
            return
        }

        if (!touchMoved.value && touchDuration < longPressDelay) {
            console.log('Touch normal en:', unitId)
        }
    }

    const handleTouchMove = () => {
        touchMoved.value = true

        if (longPressTimer.value) {
            clearTimeout(longPressTimer.value)
            longPressTimer.value = null
        }
    }

    const cleanup = () => {
        if (longPressTimer.value) {
            clearTimeout(longPressTimer.value)
        }
    }

    return {
        // Variables reactivas
        isMenuVisible,
        menuPosition,
        menuElement,
        contextUnitId,
        menuStyle,
        longPressTriggered,

        // Funciones
        selectOption,
        closeMenu,
        openContextMenu,
        handleClickOutside,
        handleKeydown,
        handleTouchStart,
        handleTouchEnd,
        handleTouchMove,
        cleanup
    }
}
